export const MONITOR_OBJECT_COLOR = "#2469EF"; // 监测对象颜色